export const gtmVirtualPageView = (rest) => {
  window.dataLayer?.push({
    event: 'VirtualPageView',
    ...rest
  });
};

const eventCooldowns = new Map();

export function pushDataLayerEvent(eventName, pagePath) {
  if (typeof window === 'undefined' || !window.dataLayer) return;

  const eventKey = `${eventName}_${pagePath}`;
  if (eventCooldowns.has(eventKey)) return;

  window.dataLayer.push({ event: eventName, url: pagePath });

  eventCooldowns.set(eventKey, true);
  setTimeout(() => eventCooldowns.delete(eventKey), 2000);
}
